// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"68c92516","451":"37c82e93","457":"05948446","551":"d52c3c75","747":"efe622f4","828":"00cef0ee","842":"8eea4e61","851":"b507a301"}[chunkId] + ".chunk.js";
};